<template>
    <img
        class="logo"
        :src="image"
        alt="Midttrafik"
    >
</template>

<script>
export default {
    computed: {
        image() {
            return require("../../assets/images/logo.svg");
        }
    }
};
</script>

<style scoped>
.logo {
    max-width: 200px;

    /* For IE11 we need to set the aspect ratio. Otherwise it defaults to 150px height */
    max-height: 69px;
}
</style>
